import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, message: "" };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, message: error?.message || "Something went wrong." };
    }

    componentDidCatch(error, info) {
        console.error("ErrorBoundary caught:", error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
                    <h5 className="text-danger mb-2">Failed to load page</h5>
                    <p className="text-muted" style={{ fontSize: "13px" }}>{this.state.message}</p>
                    <button
                        className="btn btn-sm btn-outline-secondary mt-2"
                        onClick={() => { this.setState({ hasError: false }); window.history.back(); }}
                    >
                        Go Back
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;